import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../typography';
import Button from '../../button';

const StepOne = ({ qr, onNext }) => (
  <>
    <Typography text="Configura la verificación en dos pasos" type="superTitle-italic" />
    <br />
    <div className="step-one__body">
      <div className="step-one__instructions">
        <Typography text="Añade una capa extra de seguridad a tu cuenta." className="normal-text" type="paragraph" />
        <br />
        <ol>
          <li>
            Abre tu app de autenticación:
            {' '}
            <strong>Google Authenticator,</strong>
            {' '}
            <strong>Authy</strong>
            {' '}
            o similar.
          </li>
          <li>
            Toca
            {' '}
            <strong>&quot;+&quot;</strong>
            {' '}
            y eligex
            <strong>Escanear código QR.</strong>
          </li>
          <li>Apunta la cámara al código de la derecha.</li>
        </ol>
      </div>
      <div className="step-one__qr">
        <div className="qr-box">
          <img src={qr} alt="Código QR para autenticación" />
        </div>
        <p className="qr-caption">Escanea con tu app</p>
      </div>
    </div>
    <div className="setup2fa__cta">
      <Button text="Verificar" type="primary" onClick={onNext} />
    </div>
  </>
);

StepOne.propTypes = {
  qr: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default StepOne;
